import React, { useRef } from 'react';
import VerificationInput from 'react-verification-input';
import { Form } from 'react-bootstrap';
import logo from '../../../assets/images/Logo.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

function VerificationModal() {
	const navigate = useNavigate();
	const inputRef = useRef();
	const { email } = useParams();
	const location = useLocation();
	const [verificationCode, setVerificationCode] = useState('');

	useEffect(() => {
		const emailFromState = location?.state?.email;
		console.log('Email from state:', emailFromState);
	}, [location]);
	const VerificationModalNumber = async () => {
		try {
			const emailFromState = location?.state?.email;
			const token = localStorage.getItem('token');
			const response = await axios.post(
				'https://api.getcogen.com/api/verify_otp',
				{ email: emailFromState, otp_code: verificationCode },
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.data.success == true) {
				navigate('/stripe');
				toast.success(response.data.message);
			} else if (response.data.success == false) {
				toast.error(response.data.message);
				console.log(response, 'adsdsa');
			}

		} catch (error) {
			toast.error(error.response.data.message);
			console.error('Error verifying OTP:', error);
		}
	};

	const handleVerificationCodeChange = value => {
		setVerificationCode(value);
	};
	return (
		<div className='main-container form-bg-color form-bg-reg'>
			<img src={logo} className='form-logo' alt='logo' />
			{alert.length !== 0 ? alert : ''}
			<div className='form-container'>
				<div className='form-label-header'>EMAIL VERIFICATION</div>
				<p style={{ marginBottom: '42px' }}>
					Please enter the verification code to verify your email{' '}
				</p>

				<Form className='reg-form'>
					<div style={{ marginLeft: '88px' }}>
						<VerificationInput
							classNames={{
								character: 'character',
								characterInactive: 'character--inactive',
								characterSelected: 'character--selected',
							}}
							length={4}
							ref={inputRef}
							onChange={handleVerificationCodeChange}
						/>
					</div>
				</Form>
				<button
					onClick={VerificationModalNumber}
					className='btn-signup'
					style={{ marginTop: '122px' }}
				>
					Submit
				</button>
			</div>
		</div>
	);
}

export default VerificationModal;
